exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Rectangle-4 {\n  background-color: #ffffff;\n  border: solid 1px #dfe4e7; }\n\n.revenue {\n  margin-top: 0.5em;\n  height: 27px;\n  font-size: 24px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #231f20; }\n\n.B {\n  float: right; }\n\n.layer {\n  height: 23px;\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #9da6ad; }\n\n.video-container iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n.ng-valid[required], .ng-valid.required {\n  border-left: 5px solid #42A948; }\n\n.ng-invalid {\n  border: 1px; }\n\ninput.ng-invalid {\n  border: 1px solid #a11919; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/company-structure-table/company-structure-table.component.scss
// module id = ../../../../../src/app/securities-level/company-structure-table/company-structure-table.component.scss
// module chunks = main